export const team = [
    { 
        name: 'Ayushman Patel',
        role: 'Co-founder & Co-CTO',
        quote: 'Engineering the future of adventure travel, one line of code at a time, to ensure your journey is as flawless as the destination.',
        initial: 'AP'
    },
    {
        name: 'Harsh Gupta',
        role: 'CEO',
        quote: 'Our goal is to make trekking more than just reaching a destination - it\'s about the connections we forge along the way.',
        initial: 'HG'
    },
    { 
        name: 'Lucky Chelani',
        role: 'Co-founder & CTO',
        quote: 'Technology should enhance the trekking experience, not complicate it. We bring smart solutions that bring people together.',
        initial: 'LC'
    }
];